import { useInfiniteQuery } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { Wallet } from 'lucide-react';
import dayjs from '@/lib/dayjs';
import { NETWORK_NAMES } from '@/constants';
import { List } from '@/components/common/List';
import type { SelectWalletBinding } from '@/types';

export default function WalletBindingRecordsScreen() {
  const { data, fetchNextPage } = useInfiniteQuery<SelectWalletBinding[]>(
    'wallet_bindings',
    {
      params: {
        limit: 20,
      },
      showLoading: true,
    }
  );

  if (!data) return null;

  return (
    <div className="flex flex-col items-center justify-start w-full h-full gap-5 py-3 px-5">
      <List
        className="flex flex-col w-full gap-2"
        data={data}
        onScrollEnd={fetchNextPage}
      >
        {(row) => {
          return (
            <div
              key={row.id}
              className="h-stack w-full gap-2 p-1"
            >
              <div className="bg-primary/20 rounded-lg p-1.5">
                <Wallet className="w-5 h-5 text-primary" strokeWidth={2} />
              </div>
              <div className="v-stack w-full min-w-0 !items-start">
                <Typography size="1" weight={500} className="font-mono truncate w-full">
                  {`${row.address.slice(0, 6)}...${row.address.slice(-4)}`}
                </Typography>
                <Typography size="1" color="#777777">
                  {NETWORK_NAMES[row.network as keyof typeof NETWORK_NAMES] ?? row.network}
                </Typography>
              </div>
              <Typography size="1" color="#777777">
                {dayjs(row.created_at).format('YYYY/MM/DD HH:mm')}
              </Typography>
            </div>

          );
        }}
      </List>
    </div>
  );
}
